import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { PaymentDetail } from '../../models/Payment';

const RequestPaymentProfileCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_PAYMENT_PROFILE
  })
);

const RequestPaymentCommand = Command.extend({
  detail: PaymentDetail
}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_PAYMENT
  })
);

export { RequestPaymentProfileCommand, RequestPaymentCommand };
